<template>
  <div class="page">
    <div class="logo_name">
      <img src="../assets/name.png" alt="" />
    </div>
    <div class="com_info">
      <div class="com_content">
        <div class="com_name">
          {{ company.name }}
          <!-- 利川市绿之源农业科技有限公司 -->
        </div>
        <div class="com_jiangxiang" v-if="company.is_tongmeng == 1 || pingji.level == 'A'">
          <img v-if="pingji.level == 'A'" src="../assets/chaqi.png" alt="" />
          <img v-if="company.is_tongmeng == 1" src="../assets/tongmeng.png" alt="" />
          <!-- <div class="tag_img"></div>
                    <div class="tag_img"></div> -->
        </div>

        <!-- <div class="com_jiangxiang">
          <img src="../assets/shouxin1.png" alt="" />
          <img src="../assets/tongmeng.png" alt="" />
        </div> -->
      </div>
      <div class="com_add">
        <div class="com_tap">
          <div class="item">
            <span>注册资本：</span>
            <span>{{ Number(company.zhuceziben).toFixed(0) }} 万元</span>
            <!-- <span>100 万元</span> -->
          </div>
          <div class="item">
            <span>法定代表人：</span>
            <span>{{ company.faren }}</span>
            <!-- <span>郎勋鑫</span> -->
          </div>
        </div>
        <div class="row">
          <div>
            <img src="../assets/shouhouxinyuexuanzhong2x.png" alt="" />
            <span>统一信用代码</span>
          </div>
          <div>{{ company.license_code }}</div>
          <!-- <div>91422802MADYNBD50F</div> -->
        </div>
        <div class="row">
          <div>
            <img src="../assets/dizhi2x.png" alt="" />
            <span>注册地址</span>
          </div>
          <div>{{ company.address }}</div>
          <!-- <div>湖北省恩施土家族苗族自治州利川市东城街道办事处杉木社区南环大道28号福仁佳苑4楼</div> -->
        </div>
      </div>
    </div>
    <div class="xinyon_content">
      <div class="dengji_content">
        <div>
          <span>标识结果：</span>
          <span class="dengji">{{ pingji.level }}</span>
          <!-- <span class="dengji">B</span> -->
        </div>
        <div>
          <!-- <van-tag type="success" size="large" class="tag" v-if="company.is_tongmeng == 1">信用同盟</van-tag>
                    <van-tag type="success" size="large" class="tag" v-if="company.is_chengxin == 1">诚信茶企</van-tag> -->
          <!-- <span>综合评分：</span>
                    <span class="pingfen">{{ Number(pingji.score_value).toFixed(2) }}</span>
                    <span> 分</span> -->
        </div>
      </div>

      <div class="e_content">
        <div ref="radarChart" style="width: 100%; height: 100%"></div>
      </div>

      <div class="company_intro">
        <div class="introduce">
          <img src="../assets/qiyejianjie2x.png" alt="" />
          <span>企业简介</span>
        </div>

        <div class="com_inr">
          <div>
            <div class="remark">{{ company.remark }}</div>
            <!-- <div class="remark">
              利川市绿之源农业科技有限公司成立于2020年，注册资本100万元，法定代表人为郎勋鑫。公司位于湖北省恩施土家族苗族自治州利川市东城街道办事处杉木社区南环大道28号福仁佳苑4楼。公司主要从事农业科技相关业务，致力于推动当地农业发展和技术创新。
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="title">
      <div>利川市市场监督管理局&nbsp;&nbsp;&nbsp;利川市发展和改革局&nbsp;&nbsp;&nbsp;利川市农业农村局</div>
      <!-- <div></div>
            <div></div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      company: '',
      pingji: '',
      xinyongfen: [],
      value: [],

      // mokeZhibiao: [
      //   { name: '基础信用合规', max: '6' },
      //   { name: '公共信用合规', max: '32' },
      //   { name: '经营合规', max: '32' },
      //   { name: '社会责任', max: '10' },
      //   { name: '知识产权合规', max: '10' },
      //   { name: '激励信息', max: '6' },
      //   { name: '荣誉增信', max: '4.5' },
      //   { name: '绿色生产与质量安全', max: '4' },
      //   { name: '文化传承与社会公益', max: '1.5' },
      // ],

      // mokeValue: [5, 30, 26, 5, 0, 3, 1.5, 2, 0],
    }
  },
  created() {
    this.id = this.getParameterByName('id')
    // this.id = 1

    this.getList()
  },
  mounted() {},
  methods: {
    // 解析URL
    getParameterByName(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, '\\$&')
      //匹配所有符合条件的，并取最后一个
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'g')
      var results = url.match(regex)
      var tempResults = results != null && results[results.length - 1] != undefined ? results[results.length - 1] : ''
      var finalResults = regex.exec(tempResults)
      if (!finalResults) return ''
      if (!finalResults[2]) return ''
      return decodeURIComponent(finalResults[2].replace(/\+/g, ' '))
    },
    // 获取交易数据
    async getList() {
      const { data: res } = await this.$https.post('/data/chaxinma/get-info?id=' + this.id)
      if (res.resultCode == '1') {
        this.company = res.resultInfo.company
        this.pingji = res.resultInfo.pingji
        this.zhibiao = res.resultInfo.zhibiao
        this.value = res.resultInfo.value

        // 测试数据
        // this.zhibiao = this.mokeZhibiao
        // this.value = this.mokeValue

        this.$nextTick(() => {
          this.initChart()
        })
      }
      return
    },
    initChart() {
      const chart = this.$echarts.init(this.$refs.radarChart)
      const option = {
        // radar: {
        //     shape: 'polygon',
        //     radius: '58%',
        //     indicator: this.zhibiao,
        //     name: {
        //         textStyle: {
        //             color: '#000',
        //             fontSize: 14
        //         }
        //     },
        //     splitArea: {
        //         show: true,
        //         areaStyle: {
        //             // 线性渐变，从上到下
        //             color: {
        //                 type: 'linear',
        //                 x: 0,
        //                 y: 0,
        //                 x2: 0,
        //                 y2: 1,
        //                 colorStops: [
        //                     { offset: 0, color: 'rgba(0, 100, 200, 0.1)' },
        //                     { offset: 1, color: 'rgba(0, 100, 200, 0.5)' }
        //                 ]
        //             }
        //         }
        //     }
        // },
        // series: [{
        //     type: 'radar',
        //     data: [{
        //         value: this.value,
        //         areaStyle: {
        //             color: this.$echarts.graphic.RadialGradient(0.5, 0.5, 0.8, [
        //                 { offset: 0, color: 'rgba(109, 192, 255, 0.8)' },
        //                 { offset: 1, color: 'rgba(65, 120, 255, 0.5)' }
        //             ])
        //         },
        //         lineStyle: {
        //             color: '#6670ab',
        //             width: 3,
        //             shadowBlur: 10,
        //             shadowColor: 'rgba(0, 0, 0, 0.3)',
        //             shadowOffsetY: 5
        //         },
        //         symbol: 'circle',
        //         symbolSize: 8,
        //         itemStyle: {
        //             color: '#6670ab'
        //         }
        //     }]
        // }]
        radar: {
          shape: 'polygon', // 关键：设置为多边形（六边形）[5](@ref)
          radius: '58%',
          indicator: this.zhibiao,
          name: {
            textStyle: {
              color: '#9d9d9f',
              fontSize: 10,
            },

            formatter(value) {
              if (value.length <= 6) return value
              return value.match(/.{1,6}/g).join('\n')
            },
          },
          splitArea: {
            // 启用多边形区域分隔
            show: true,
            areaStyle: {
              color: ['#ffffff', '#f5f5fd'], // 渐变色增强层次感[5](@ref)
            },
          },
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: this.value, // 六个维度的值
                areaStyle: { color: '#c0d9f8' }, // 填充色
                lineStyle: { color: '#5870d4' }, // 线条色
              },
            ],
            // itemStyle: {
            //     color: 'transparent',          // 透明填充 → 空心
            //     borderColor: '#6279df',        // 边框颜色（与线条色一致）
            //     borderWidth: 0.5                 // 边框粗细
            // }
          },
        ],
      }
      chart.setOption(option)
      // 添加视角旋转动画（可选）
      let angle = 0
      window.addEventListener('resize', chart.resize) // 响应式调整
    },
  },
}
</script>

<style lang="less" scoped>
[v-cloak] {
  display: none;
}

.page {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: url(../assets/bgc2x.png) center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  padding-bottom: 16px;
  position: relative;
}

.logo_name {
  width: 100%;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  position: absolute;
  left: 0;
  top: 0;
}

.logo_name img {
  width: 235px;
  height: 100%;
}

.com_info {
  margin-top: 120px;
  width: 90%;
  margin-left: 5%;
  // height: 300px;
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  // padding-bottom: 30px;
}

.com_content {
  width: 100%;
  // background-color: pink;
  // height: 70px;
  border-bottom: 1px dashed #e4e4e4;
  padding-bottom: 4px;
  // padding: 12px 0;
}

.com_name {
  color: #2e2e2e;
  font-weight: 500;
  font-size: 18px;
}

.com_tap {
  width: 100%;
  height: 60px;
  // background-color: pink;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.item {
  // width: 130px;
  padding: 0 8px;
  height: 32px;
  border: 1px solid #007df9;
  background-color: #e0ecff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #007df9;
}

.item:nth-child(1) {
  margin-right: 8px;
}

.item > span:nth-child(1) {
  color: #828da3;
}

.com_add {
  width: 100%;
  margin-top: 6px;
  // height: 160px;
}

.row {
  width: 100%;
  min-height: 70px;
  background-color: #eff8ff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px 16px;
}

.row img {
  width: 12px;
  height: 13px;
}

.row:nth-child(2) {
  margin-bottom: 16px;
}

.row > div {
  width: 100%;
  // height: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-wrap: normal;
  color: #3f464c;
}

.row > div img {
  margin-right: 6px;
}

.row > div:nth-child(1) {
  color: #8f999b;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 6px;
}

.xinyon_content {
  margin-top: 16px;
  width: 90%;
  margin-left: 5%;
  // height: 480px;
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  padding-bottom: 10px;
}

.dengji_content {
  width: 100%;
  height: 55px;
  background-color: #eaf4fe;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  color: #000107;
  font-weight: 600;
  font-size: 16px;
}

.dengji {
  color: #ea7d18;
  font-size: 24px;
}

.pingfen {
  font-size: 22px;
}

.e_content {
  width: 100%;
  height: 300px;
  // background-color: pink;
  display: flex;
  justify-content: center;
  align-items: center;
}

.company_intro {
  background-color: #eff8ff;
  border-radius: 12px;
  margin: 20px;
  box-sizing: border-box;
  margin: 20px 20px 10px;
  overflow: hidden;
}

.com_inr {
  width: 100%;
  // height: 120px;
  // background-color: pink;
  padding: 0 20px;
  box-sizing: border-box;
  max-height: 200px;
  overflow: auto;
  /* 允许滚动 */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* Internet Explorer 10+ */
  // border-radius: 12px;
  // margin-top: 25px;
  margin: 5px 0 10px;
}

.introduce {
  display: flex;
  align-items: center;
  min-height: 28px;
  background-color: #eff8ff;

  padding: 5px 10px;
  gap: 6px;

  img {
    width: 16px;
    height: 18px;
  }
}

.remark {
  min-height: 60px !important;
  color: #8f999b;
  // font-weight: 600;
  font-size: 16px;
  margin-bottom: 6px;
  text-indent: 2em;
}

.com_jiangxiang {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  margin-top: 2px;
}

.com_jiangxiang img {
  height: 26px;
}

.com_jiangxiang img:nth-child(1) {
  margin-right: 10px;
}

.title {
  // height: 40px;
  width: 100%;
  // background-color: pink;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 12px;
}
</style>
